import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/royalmail_negative.png'


const _hoisted_1 = {
  class: "mb-3 mt-3",
  style: {"text-align":"left"}
}
const _hoisted_2 = { class: "card mb-3 mt-3" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = {
  key: 0,
  class: "invalid"
}
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = {
  key: 0,
  class: "invalid"
}
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = {
  key: 0,
  class: "invalid"
}
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "invalid" }
const _hoisted_15 = {
  key: 0,
  class: "card mb-3",
  id: "div-orderitems"
}
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "card-title" }
const _hoisted_18 = ["for"]
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = ["id", "value", "disabled"]
const _hoisted_21 = { class: "product-name" }
const _hoisted_22 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_23 = {
  key: 0,
  class: "col-sm-12 invalid"
}
const _hoisted_24 = {
  key: 0,
  class: "card mb-3",
  id: "div-returnreasons"
}
const _hoisted_25 = { class: "card-body" }
const _hoisted_26 = { class: "dropdown mb-3" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  class: "dropdown-menu",
  "aria-labelledby": "returnreason-dropdown"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  class: "dropdown-menu",
  "aria-labelledby": "return-resolution-dropdown"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = ["href"]
const _hoisted_44 = ["href"]
const _hoisted_45 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "invalid" }
const _hoisted_49 = {
  key: 0,
  id: "submitsuccess",
  class: "card mb-4"
}
const _hoisted_50 = { class: "container" }
const _hoisted_51 = { class: "row mb-3" }
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = ["href"]
const _hoisted_57 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[12] || (_cache[12] = _createElementVNode("h4", { class: "card-title" }, "Need to return your item?", -1)),
        _cache[13] || (_cache[13] = _createElementVNode("p", null, [
          _createElementVNode("b", null, " If your item has developed a fault or you've just changed your mind, please follow the steps below to return your item to us. ")
        ], -1)),
        _cache[14] || (_cache[14] = _createElementVNode("h5", null, "Find your Order", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("label", {
            for: "orderNumberInput",
            class: "form-label"
          }, "Enter your order number below", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["form-control", {
                            'is-invalid': _ctx.valmsg.orderNumber && _ctx.editedOrderNumber,
                            'is-valid': !_ctx.valmsg.orderNumber && _ctx.editedOrderNumber
                        }]),
            id: "orderNumberInput",
            placeholder: "Order number (e.g. 123456)",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderNumber) = $event))
          }, null, 2), [
            [_vModelText, _ctx.orderNumber]
          ]),
          (_ctx.valmsg.orderNumber)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.valmsg.orderNumber), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[9] || (_cache[9] = _createElementVNode("label", {
            for: "customerEmailInput",
            class: "form-label"
          }, "Enter your email address below", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "email",
            class: _normalizeClass(["form-control", {
                            'is-invalid': _ctx.valmsg.email && _ctx.editedEmail,
                            'is-valid': !_ctx.valmsg.email && _ctx.editedEmail
                        }]),
            id: "customerEmailInput",
            placeholder: "Email Address",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customerEmail) = $event))
          }, null, 2), [
            [_vModelText, _ctx.customerEmail]
          ]),
          (_ctx.valmsg.email)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.valmsg.email), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[10] || (_cache[10] = _createElementVNode("label", {
            for: "customerPostCodeInput",
            class: "form-label"
          }, "Enter the postcode that the item was delivered to below", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["form-control", {
                            'is-invalid': _ctx.valmsg.postcode && _ctx.editedPostcode,
                            'is-valid': !_ctx.valmsg.postcode && _ctx.editedPostcode
                        }]),
            id: "customerPostCodeInput",
            placeholder: "Postcode",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customerPostCode) = $event))
          }, null, 2), [
            [_vModelText, _ctx.customerPostCode]
          ]),
          (_ctx.valmsg.postcode)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.valmsg.postcode), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary mb-2",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getOrderItems && _ctx.getOrderItems(...args))),
            disabled: !_ctx.areDetailsValid || _ctx.getOrderItemsLoading
          }, [
            (_ctx.getOrderItemsLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12))
              : _createCommentVNode("", true),
            _cache[11] || (_cache[11] = _createTextVNode(" Find order "))
          ], 8, _hoisted_11),
          (_ctx.orderFormErrorMsg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.orderFormErrorMsg), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.orderItems!= null && _ctx.orderItems.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("h5", _hoisted_17, "Items for order " + _toDisplayString(_ctx.lastValidOrderNumber), 1),
                _cache[15] || (_cache[15] = _createElementVNode("h6", { class: "card-title" }, "Select the item you wish to return", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["card mb-3 g-0", ((_ctx.selectedReturnItem != null && _ctx.selectedReturnItem.raspOrderItemID == item.raspOrderItemID) ? 'selected' : '')]),
                    key: item.raspOrderItemID
                  }, [
                    _createElementVNode("label", {
                      for: 'radio-'+item.raspOrderItemID
                    }, [
                      _createElementVNode("div", _hoisted_19, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          id: 'radio-'+item.raspOrderItemID,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedReturnItem) = $event)),
                          value: item,
                          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.scrollToReturnReasons && _ctx.scrollToReturnReasons(...args))),
                          disabled: item.returnItemMessage != null || _ctx.requestSubmitSuccess
                        }, null, 40, _hoisted_20), [
                          [_vModelRadio, _ctx.selectedReturnItem]
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createTextVNode(_toDisplayString(item.productName) + " ", 1),
                          (item.reference)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_22, _toDisplayString(item.reference), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (item.returnItemMessage)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(item.returnItemMessage), 1))
                          : _createCommentVNode("", true)
                      ])
                    ], 8, _hoisted_18)
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.returnReasons.length > 0 && _ctx.returnItemSelected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[20] || (_cache[20] = _createElementVNode("h4", { class: "card-title" }, "Reason for Return", -1)),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("button", {
                    class: "btn btn-secondary dropdown-toggle",
                    type: "button",
                    id: "returnreason-dropdown",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false",
                    disabled: _ctx.requestSubmitSuccess
                  }, [
                    (_ctx.selectedReturnReason == null)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_28, "Select a reason"))
                      : (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.selectedReturnReason.websiteText), 1))
                  ], 8, _hoisted_27),
                  _createElementVNode("ul", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.returnReasons, (returnreason) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: returnreason.returnReasonId
                      }, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: ($event: any) => (_ctx.changeReturnReason(returnreason)),
                          href: "javascript:void(0)"
                        }, _toDisplayString(returnreason.websiteText), 9, _hoisted_31)
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode(_Transition, {
                  name: "fade",
                  appear: ""
                }, {
                  default: _withCtx(() => [
                    (_ctx.returnReasonSelected)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _cache[16] || (_cache[16] = _createElementVNode("label", {
                            for: "additionalReturnReasonBox",
                            class: "form-label"
                          }, [
                            _createElementVNode("h5", null, "Additional information")
                          ], -1)),
                          (_ctx.returnReasonFaulty)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_33, "Please provide us with a description of the fault"))
                            : _createCommentVNode("", true),
                          _withDirectives(_createElementVNode("textarea", {
                            id: "additionalReturnReasonBox",
                            rows: "3",
                            class: "form-control mb-3",
                            placeholder: "Please provide more details",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.customerReturnText) = $event)),
                            disabled: _ctx.disableResolutionSection
                          }, null, 8, _hoisted_34), [
                            [_vModelText, _ctx.customerReturnText]
                          ]),
                          _cache[17] || (_cache[17] = _createElementVNode("h5", { class: "card-title" }, "Resolution", -1)),
                          _createElementVNode("button", {
                            class: "btn btn-secondary dropdown-toggle",
                            type: "button",
                            id: "return-resolution-dropdown",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false",
                            disabled: _ctx.disableResolutionSection
                          }, [
                            (_ctx.selectedResolution == null)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_36, "Please select a resolution"))
                              : (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.selectedResolution.text), 1))
                          ], 8, _hoisted_35),
                          _createElementVNode("ul", _hoisted_38, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.returnResolutionOptions, (res) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: res.value
                              }, [
                                _createElementVNode("a", {
                                  href: "javascript:void(0)",
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.selectedResolution = res)
                                }, _toDisplayString(res.text), 9, _hoisted_39)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_ctx.showReturnsPolicyWarning || _ctx.showWarrantyPeriodWarning)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      (_ctx.showWarrantyPeriodWarning)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("b", null, "Sorry, the item is outside of our " + _toDisplayString(_ctx.selectedReturnItem?.warrantyMonths) + " month warranty period.", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.showReturnsPolicyWarning && !_ctx.showWarrantyPeriodWarning)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createElementVNode("b", null, "Sorry, the item is outside of our " + _toDisplayString(_ctx.selectedReturnItem?.returnsPolicyDays) + " day returns policy.", 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _cache[18] || (_cache[18] = _createTextVNode(" If you would like further information, please see our ")),
                        _createElementVNode("a", { href: _ctx.termsAndConditionsLink }, "terms & conditions", 8, _hoisted_43),
                        _cache[19] || (_cache[19] = _createTextVNode(". If you have any more questions please contact us at ")),
                        _createElementVNode("a", { href: _ctx.emailLink }, _toDisplayString(_ctx.emailLink?.split(':')[1]), 9, _hoisted_44)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.returnReasonSelected && _ctx.returnItemSelected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitReturnRequest && _ctx.submitReturnRequest(...args))),
                disabled: _ctx.disableSubmitReturnRequest
              }, " Submit Return Request ", 8, _hoisted_46),
              (_ctx.submitErrorMsg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.submitErrorMsg), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.requestSubmitSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _cache[39] || (_cache[39] = _createElementVNode("div", { class: "row mb-2" }, [
                  _createElementVNode("div", {
                    class: "col-sm-12 alert alert-success",
                    role: "alert"
                  }, " Thank you! Now follow these instructions on how to return your item to us: ")
                ], -1)),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _cache[22] || (_cache[22] = _createElementVNode("h5", null, "Step 1", -1)),
                    _cache[23] || (_cache[23] = _createElementVNode("p", null, " Please place your item along with any or all accessories back in the original box, you can wrap the whole box in bubble packaging for added protection. If you no longer have the box please ensure the item is placed in a secure rigid container to prevent any movement in the post. ", -1)),
                    (!_ctx.isConfigCC)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_53, _cache[21] || (_cache[21] = [
                          _createTextVNode(" If your item has any manufacturer account locks and or passwords please ensure these are removed prior to returning your item, for ease of your return we have linked instructions from the most common manufacturer account locks below, should the item you have received have an account lock that you are unable to remove please call us on 0330 120 1541 prior to posting your item. "),
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", { href: "https://support.apple.com/en-us/HT208855" }, "Unlink your Apple product from your iCloud")
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", { href: "https://support.google.com/android/answer/7664951?hl=en" }, "Unlink your product from your Google account")
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", { href: "https://support.ring.com/hc/en-gb/articles/360038010351-How-to-take-over-or-change-ownership-of-a-Ring-device" }, "Unlink your item from your Ring Door account")
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", { href: "https://support.google.com/googlenest/answer/9691327?hl=en-GB" }, "Unlink your item from your Google Nest account")
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", { href: "https://www.philips-hue.com/en-gb/support/faq/apps-and-software#How_do_I_remove_an_unused_smart_device_from_my_Philips_Hue_system" }, "Unlink your item from your Philips Hue account")
                            ])
                          ], -1)
                        ])))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _cache[38] || (_cache[38] = _createElementVNode("h5", null, "Step 2", -1)),
                    (_ctx.showRoyalMailPortal)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "mb-3" }, [
                            _createElementVNode("img", {
                              src: _imports_0,
                              alt: "Royal Mail Logo"
                            }),
                            _createElementVNode("p", null, "Return through your local Post Office branch or Royal Mail Customer Service Point in over 12,000 locations. Open 7 days a week, early until late.")
                          ], -1)),
                          _createElementVNode("div", null, [
                            _createElementVNode("a", {
                              href: _ctx.config?.rmPortalLink,
                              target: "_blank",
                              class: "btn btn-primary",
                              role: "button"
                            }, "Create Return Label", 8, _hoisted_56)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                          _createElementVNode("p", null, [
                            _cache[37] || (_cache[37] = _createTextVNode(" Please send your device to the following address including your order number: ")),
                            _createElementVNode("b", null, [
                              _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(_toDisplayString(_ctx.lastValidOrderNumber) + " ", 1),
                              _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(_toDisplayString(_ctx.config?.siteFullName) + " ", 1),
                              _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                              _cache[28] || (_cache[28] = _createTextVNode("Kingswood Lakeside ")),
                              _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
                              _cache[30] || (_cache[30] = _createTextVNode("Blakeney Way ")),
                              _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
                              _cache[32] || (_cache[32] = _createTextVNode("Kingswood Lakeside ")),
                              _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
                              _cache[34] || (_cache[34] = _createTextVNode("Cannock ")),
                              _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
                              _cache[36] || (_cache[36] = _createTextVNode("WS11 8JD "))
                            ])
                          ])
                        ]))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}